import { Component, OnInit, Input, ElementRef, trigger, transition, style, animate, state } from '@angular/core';
import { EBEpouchdbService } from '../../../EBE/EBEpouchdb.service';
import { BrowserModule, DomSanitizer } from '@angular/platform-browser';
import { Mindmap } from '../../../shared/models/mindmap';
import { BookData } from '../../../shared/models/bookData';
import { Page } from '../../../shared/models/page';
import * as _ from 'lodash';
var CANVAS;
@Component({
  selector: 'app-smartview',
  templateUrl: './smartview.component.html',
  styleUrls: ['./smartview.component.css'],
  animations: [
    trigger(
      'myAnimation',
      [
        transition(
          ':enter', [
            animate('500ms', style({ height: 'auto' }))
          ]
        ),
        transition(
          ':leave', [
            animate('500ms', style({ height: '0' })),
          ]
        )
      ]
    )
  ],
})
export class SmartviewComponent implements OnInit {
  @Input() data: any;
  show = 'Pages';

  totalpage
  enableFilter = false;
  isListView = false;
  BookPages;
  show2nddata = undefined;
  show3nddata = undefined;
  show4nddata = undefined;
  openSubMenu = false;
  openSubMenu1 = false;
  openSubMenu3 = false;
  selectedFilters = [];
  paddingleftCount = 10;
  constructor(private ele: ElementRef, private pouchService: EBEpouchdbService, private sanitizer: DomSanitizer) {


  }
  BookPagesNo: any = [];
  pdfPagesNo: any = [];
  pageObj: any = {};
  totalpdfpage;
  bookDataObj: BookData;
  pageCount;
  pages = [];
  allFilterEnabled = false;
  bookscat: any = ["Pages", "Structure View"];
  filterCategory =
    [
      { 'name': 'BookMarks', 'isFilter': false, 'type': 'bookmarks' },
      { 'name': 'Drawing', 'isFilter': false, 'type': 'drawing' },
      { 'name': 'Enrichments', 'isFilter': false, 'type': 'enrichment_page' },
      { 'name': 'Notes', 'isFilter': false, 'type': 'notes' },
      { 'name': 'Annotations', 'isFilter': false, 'type': 'annotations' }
    ]
  mindMapModel: any;
  ngOnInit() {
    if (this.data && this.data.popupProps) {
      if (this.data.popupProps.hidePagesList == true) {
        this.loadMindMap('Structure View', '');

        this.show = 'Structure View';
      }
      this.bookDataObj = this.data.popupProps.bookDataObj;
      this.pageCount = this.data.popupProps.pageCount;

      //To create static pages array
      for (let i = 0; i < this.pageCount; i++) {

        if (this.bookDataObj[i + 1]) {

          this.pages.push(this.bookDataObj[i + 1]);
          this.selectedFilters.push(this.bookDataObj[i + 1]);
        }
        else {
          this.pageObj = new Page();
          this.pageObj.pageNumber = i + 1;
          this.pages.push(this.pageObj);
          this.selectedFilters.push(this.pageObj);
        }

      }

      for (var i = 1; i <= this.selectedFilters.length; i++) {
        if (i < 10) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-00" + i + ".JPG";
        }
        else if (i == 10) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-010.JPG";

        }
        else if (i == 100) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-100.JPG";

        }
        else if (i > 100) {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-" + i + ".JPG";
        }
        else {
          var url = "http://hyd.semanoor.com/NooorM/pdf/0f9d5153-43c4-44ff-b600-39f52bf09981/Thumbs/PDF-0" + i + ".JPG";
        }
        this.selectedFilters[i - 1].url = url;

      }
    }
  }
  mindmapLayer;

  mindMapRenderObject: any

  loadMindMap(data, event) {

    // event.stopPropagation();
    this.show = data;

    if (data == 'Structure View') {

      this.mindMapRenderObject = {
        'bookDataObj': this.data.popupProps.bookDataObj,
        'title': this.data.popupProps.curComp.bookObj.title,
        'showCloseButton': false,
        'componentState': this.data.popupProps.componentState,
        'hidePagesHeader': this.data.popupProps.hidePagesHeader

      };
    }


  }


  applyFiltersForPages() {

    var matchedArray = _.find(this.pages, function (o) { return o.age < 40; });
  }



  openCloseTab1(evt, ind, pgdata) {
    for (let m = 0; m < pgdata.enrichment_page.length; m++) {
      pgdata.enrichment_page[m].isChildrenShow = true;
    }
    if (ind != this.show2nddata && this.openSubMenu == true) {
      this.openSubMenu = !this.openSubMenu;
    }
    this.openSubMenu = !this.openSubMenu;
    this.show2nddata = ind;
    // this.showToggleIcon = !this.showToggleIcon;
  }

  traverseObj: any

  gotoEnrichment(nodeData, parentData) {

    // this.traverseObj = [
    //   {
    //     'index': nodeData.index,
    //     'data': nodeData
    //   }
    // ];

    // for (var i = 0; i < nodeData.level; i++) {

    //   // if (changingTraverseObj.m_parentPage) {

    //   //     var data = getTraverseObj(changingTraverseObj.m_parentPage)
    //   //     var dataobj = {
    //   //         'index': data.index,
    //   //         'data': data
    //   //     }
    //   //     traverseObj.push(dataobj);
    //   //     changingTraverseObj = changingTraverseObj.m_parentPage;

    //   // }

    // }
  }

  showHideChildren(event, nodeData, parentData) {
    for (var c = 0; c < parentData.length; c++) {
      //  parentData[c].color = '';
      // parentData[c].padingLft = '0';
    }
    for (var q = 0; q < nodeData.children.length; q++) {
      // nodeData.children[q].color = 'red';
      // nodeData.children[q].padingLft = "20";
      nodeData.children[q].isChildrenShow = true;
      nodeData.children[q].showToggleIcon = false;
    }
    event.stopPropagation();
    nodeData.isChildrenShow = !nodeData.isChildrenShow
    nodeData.showToggleIcon = !nodeData.showToggleIcon;

    this.gotoEnrichment(nodeData, parentData)
  }

  currentPage = 1;
  timerInterval;


  CURRENT_PAGE;
  PAGE_RENDERING_IN_PROGRESS = 0;
  CANVAS;
  __CANVAS_CTX;
  PDF_DOC;

  isBookMark = true;
  isDrawing = true;
  isEnrichments = false;
  isNote = true;
  isAnnotations = true;

  selectedFiltersNames;
  //BookPagesNoTemp = [];}

  gotoPageFromEnrichpopup(obj) {

    this.data.popupProps.curComp.onNotify({ 'state': 'pagesIndex', 'pdfInx': obj.pageNumber - 1 });

  }

  addremoveFilters() {
    this.allFilterEnabled = !this.allFilterEnabled;

    if (this.allFilterEnabled == false) {
      this.filterCategory.forEach(function (category) {
        category.isFilter = false;
      })

      this.selectedFilters = this.pages;

    }

    else if (this.allFilterEnabled == true) {
      this.filterCategory.forEach(function (category) {
        category.isFilter = true;
      })
      this.formFilterMatchArray()
    }

  }

  filterPageData(ind) {

    if (ind == 0) {
      this.isBookMark = !this.isBookMark;
    } else if (ind == 1) {
      this.isDrawing = !this.isDrawing
    } else if (ind == 2) {
      this.isEnrichments = !this.isEnrichments;
    } else if (ind == 3) {
      this.isNote = !this.isNote;
    }

    this.filterCategory[ind].isFilter = !this.filterCategory[ind].isFilter;

    this.formFilterMatchArray()

    if (this.selectedFiltersNames.length == this.filterCategory.length) {
      this.allFilterEnabled = true;
    }

    else {
      this.allFilterEnabled = false;
    }

  }

  formFilterMatchArray() {

    this.selectedFiltersNames = _.map(_.filter(this.filterCategory, function (filter) { return filter.isFilter == true; }), 'type');

    var self = this;

    if (this.selectedFiltersNames.length > 0) {

      this.selectedFilters = _.filter(this.pages, function (filter) {
        var val = self.selectedFiltersNames[0];
        var a, b, c, d = [], e = []
        for (var i = 0; i < self.selectedFiltersNames.length; i++) {
          if (self.selectedFiltersNames[i] == 'bookmarks') {
            a = filter.bookmarks;
          }
          if (self.selectedFiltersNames[i] == 'drawing') {
            b = filter.drawing;
          }
          if (self.selectedFiltersNames[i] == 'annotations') {
            c = filter.annotations;
          }
          if (self.selectedFiltersNames[i] == 'notes') {
            d = filter.notes;
          }
          if (self.selectedFiltersNames[i] == 'enrichment_page') {
            e = filter.enrichment_page;
          }

        }
        return a == 1 || b == 1 || c == 1 || d.length > 0 || e.length > 0;
      });
    }

    else {
      this.selectedFilters = this.pages;
    }


  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/smartview/smartview.component.ts